import { FC, useEffect, MouseEvent } from "react";
import { useMutation } from "react-query";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import moment from "moment";
import {
  billWsieReportSearchInternalCodeService,
  billWsieReportSearchService,
  billWsieReportService,
} from "./service";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { clinicId } from "../../../constants";
import useRepotFile from "../../hooks/reportFileHook";
import useAuthentication from "../../../hooks/useAuthentication";

const BillWiseReport: FC = () => {
  const { control, reset, getValues } = useForm();
  const { user } = useAuthentication();
  const isInternalCodeType =
    String(user?.codetype || "").toLowerCase() === "internal";
  const {
    mutate: searchbills,
    data: searchData,
    isLoading: searchDataDataLoading,
    reset:resetMutation
  } = useMutation(
    isInternalCodeType
      ? billWsieReportSearchInternalCodeService
      : billWsieReportSearchService,
  );

  const { mutate: getPdf, isLoading: pdfLoading } = useRepotFile({
    apiFunction: billWsieReportService,
    responseFileKey:"file"
  });

  const onChange = () => {
    const data = getValues();
    if (data?.fromDate && data?.toDate) {
      searchbills({ ...data, clinicId });
    }else{
      resetMutation()
    }
  };

  useEffect(() => {
    searchbills({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId,
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
  }, []);

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

  useEffect(()=>{
    searchbills({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId
    });

     reset({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        })
  },[])

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getPdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId,
      });
    }
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Bill Wise Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button type="submit">search</Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              pdfLoading ||
              searchDataDataLoading ||
              !Boolean(searchData?.response?.length)
            }
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
        </div>
        <TableComponent
          loading={searchDataDataLoading}
          data={searchData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default BillWiseReport;
const heading = [
  { heading: "Patient Name", key: "patientName" },
  { heading: "Doctor", key: "doctor" },
  { heading: "EMR NO/Reg No", key: "emrno" },
  { heading: "Item Code", key: "itemCode" },
  { heading: "Item Name", key: "itemName" },
  { heading: "item Group Name", key: "itemGroupName" },
  { heading: "Quantity ", key: "quantity" },
  { heading: "Rate", key: "rate" },
  { heading: "Gross Amount", key: "grossAmount" },
];
